exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.datetime-with-clear[data-v-1bb8d17c] {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n}\n.clear-button[data-v-1bb8d17c] {\n    position: absolute;\n    right: 8px;\n    top: 65%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px 8px;\n    color: #999;\n    font-size: 14px;\n    line-height: 1;\n    z-index: 10;\n    transition: color 0.2s ease;\n}\n.clear-button[data-v-1bb8d17c]:hover {\n    color: #333;\n}\n.clear-button[data-v-1bb8d17c]:focus {\n    outline: 2px solid #007bff;\n    outline-offset: 2px;\n}\n", ""]);

// exports
